export const tr = {
    'empty-header': 'Anahtar sözcük grupları seçilmedi',
    'empty-text': 'Reklam grubuna ekleyebileceğiniz anahtar sözcük gruplarının listesi burada gösterilir',
    'remove-action': 'Listeyi temizle',
    title: 'Anahtar sözcük grupları'
};
